const Wishlist = {
  key: 'hape_wishlist',

  get() {
    try {
      const stored = JSON.parse(
        localStorage.getItem(this.key)
      ) || [];

      return stored.map(item => {
        if (typeof item === 'object' && item !== null) {
          return {
            id: String(item.id),
            handle: item.handle || null
          };
        }

        return {
          id: String(item),
          handle: null
        };
      });
    } catch (error) {
      console.error('Wishlist get error:', error);
      return [];
    }
  },

  save(items) {
    localStorage.setItem(
      this.key,
      JSON.stringify(items)
    );

    this.refreshUI();
  },

  has(productId) {
    const id = String(productId);

    return this.get().some(
      item => item.id === id
    );
  },

  toggle(productId, handle = null) {
    const id = String(productId);

    let items = this.get();

    const existingIndex = items.findIndex(
      item => item.id === id
    );

    if (existingIndex !== -1) {
      items.splice(existingIndex, 1);
    } else {
      items.push({
        id: id,
        handle: handle
      });
    }

    this.save(items);
  },

  remove(productId) {
    const id = String(productId);

    const items = this.get().filter(
      item => item.id !== id
    );

    this.save(items);
  },

  refreshUI() {
    const items = this.get();

    /*
     * CORAZONES
     */
    document
      .querySelectorAll('[data-wishlist-product]')
      .forEach(button => {
        const id = String(
          button.dataset.wishlistProduct
        );

        const active = items.some(
          item => item.id === id
        );

        button.classList.toggle(
          'is-active',
          active
        );

        button.setAttribute(
          'aria-pressed',
          active ? 'true' : 'false'
        );

        button.setAttribute(
          'aria-label',
          active
            ? 'Quitar de favoritos'
            : 'Agregar a favoritos'
        );
      });


    /*
     * CONTADOR HEADER
     */
    document
      .querySelectorAll('[data-wishlist-count]')
      .forEach(counter => {
        counter.textContent = items.length;

        counter.hidden =
          items.length === 0;
      });


    /*
     * CONTADOR DRAWER
     */
    document
      .querySelectorAll('[data-wishlist-drawer-count]')
      .forEach(counter => {
        counter.textContent = items.length;
      });
  }
};


/* =========================================================
   UTILIDADES
   ========================================================= */

function getShopRoot() {
  return window.Shopify?.routes?.root || '/';
}


function formatWishlistMoney(cents) {
  const amount = Math.round(cents / 100);

  return '$' + amount.toLocaleString('en-US');
}


function escapeWishlistHTML(value) {
  return String(value ?? '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');
}


/* =========================================================
   CONTROL DE RENDER
   ========================================================= */

let wishlistRenderId = 0;


/* =========================================================
   RENDER DRAWER
   ========================================================= */

async function renderWishlistDrawer() {
  const container = document.querySelector(
    '[data-wishlist-drawer-content]'
  );

  if (!container) return;

  const currentRenderId = ++wishlistRenderId;

  const items = Wishlist.get();

  const emptyState = document.querySelector(
    '[data-wishlist-empty]'
  );


  /*
   * VACÍO
   */
  if (!items.length) {
    container.innerHTML = '';

    if (emptyState) {
      emptyState.style.display = '';
    }

    return;
  }


  if (emptyState) {
    emptyState.style.display = 'none';
  }


  /*
   * LOADING
   */
  container.innerHTML = `
    <div class="wishlist-drawer__loading">
      Cargando favoritos...
    </div>
  `;


  const products = [];


  /*
   * CARGAMOS PRODUCTOS
   */
  for (const item of items) {
    if (!item.handle) {
      continue;
    }

    try {
      const response = await fetch(
        `${getShopRoot()}products/${item.handle}.js`,
        {
          headers: {
            Accept: 'application/json'
          }
        }
      );


      /*
       * Otro render empezó.
       */
      if (currentRenderId !== wishlistRenderId) {
        return;
      }


      if (!response.ok) {
        console.warn(
          `Wishlist: no se pudo cargar ${item.handle}`
        );

        continue;
      }


      const product = await response.json();


      /*
       * Evitar duplicados.
       */
      const alreadyExists = products.some(
        existing =>
          String(existing.id) === String(product.id)
      );

      if (!alreadyExists) {
        products.push(product);
      }

    } catch (error) {
      console.error(
        'Wishlist drawer product error:',
        error
      );
    }
  }


  if (currentRenderId !== wishlistRenderId) {
    return;
  }


  /*
   * No pudimos recuperar productos.
   */
  if (!products.length) {
    container.innerHTML = '';

    if (emptyState) {
      emptyState.style.display = '';
    }

    return;
  }


  container.innerHTML = '';


  /*
   * RENDER PRODUCTOS
   */
  products.forEach(product => {
    const price =
      formatWishlistMoney(product.price);

    const image =
      product.featured_image || '';

    const productUrl =
      product.url ||
      `${getShopRoot()}products/${product.handle}`;


    /*
     * Primera variante disponible.
     */
    const availableVariant =
      product.variants?.find(
        variant => variant.available
      ) ||
      product.variants?.[0];


    const variantId =
      availableVariant?.id;


    const html = `
      <div
        class="cart__item wishlist-cart-item is-animated"
        data-wishlist-drawer-item="${product.id}"
      >

        <div class="cart__item__image">

          <a
            href="${productUrl}"
            aria-label="${escapeWishlistHTML(product.title)}"
          >
            <div class="lazy-image">

              ${
                image
                  ? `
                    <img
                      src="${image}"
                      alt="${escapeWishlistHTML(product.title)}"
                      width="180"
                      height="180"
                      loading="lazy"
                      sizes="90px"
                    >
                  `
                  : ''
              }

            </div>
          </a>

        </div>


        <div class="cart__item__content">

          <div class="cart__item__content__left">

            <div class="cart__item__content-inner">

              <h4 class="cart__item__title" style="font-size: 0.9rem;">
                <a href="${productUrl}">
                  ${escapeWishlistHTML(product.title)}
                </a>
              </h4>

              <div class="cart__item__meta body-x-small"></div>

            </div>


            <div class="wishlist-cart-item__actions">

              ${
                variantId
                  ? `
                    <button
                      type="button"
                      class="btn btn--primary btn--solid wishlist-cart-item__add"
                      data-wishlist-add-cart
                      data-product-id="${product.id}"
                      data-variant-id="${variantId}"
                    >
                      Agregar al carrito
                    </button>
                  `
                  : ''
              }


                <button
                type="button"
                class="wishlist-cart-item__remove"
                data-wishlist-remove="${product.id}"
                aria-label="Quitar ${escapeWishlistHTML(product.title)} de favoritos"
                >
                Quitar
                </button>

            </div>

          </div>


          <div class="cart__item__content__right">

            <div class="cart__item__price">
              ${price}
            </div>

          </div>

        </div>

      </div>
    `;


    container.insertAdjacentHTML(
      'beforeend',
      html
    );
  });
}


/* =========================================================
   ABRIR DRAWER
   ========================================================= */

function openWishlistDrawer() {
  const drawer = document.querySelector(
    '[data-wishlist-drawer]'
  );

  if (!drawer) return;


  renderWishlistDrawer();


  drawer.classList.add('is-open');

  drawer.setAttribute(
    'aria-hidden',
    'false'
  );


  document.dispatchEvent(
    new CustomEvent(
      'theme:scroll:lock',
      {
        bubbles: true
      }
    )
  );


  document.dispatchEvent(
    new CustomEvent(
      'theme:wishlist-drawer:open',
      {
        bubbles: true,
        detail: {
          target: drawer
        }
      }
    )
  );
}


/* =========================================================
   CERRAR DRAWER
   ========================================================= */

function closeWishlistDrawer() {
  const drawer = document.querySelector(
    '[data-wishlist-drawer]'
  );

  if (!drawer) return;


  if (!drawer.classList.contains('is-open')) {
    return;
  }


  drawer.classList.remove('is-open');

  drawer.setAttribute(
    'aria-hidden',
    'true'
  );


  document.dispatchEvent(
    new CustomEvent(
      'theme:scroll:unlock',
      {
        bubbles: true
      }
    )
  );


  document.dispatchEvent(
    new CustomEvent(
      'theme:wishlist-drawer:close',
      {
        bubbles: true,
        detail: {
          target: drawer
        }
      }
    )
  );
}


/* =========================================================
   AGREGAR FAVORITO AL CARRITO
   ========================================================= */

async function addWishlistProductToCart(button) {
  const variantId =
    button.dataset.variantId;

  const productId =
    button.dataset.productId;


  if (!variantId || !productId) {
    return;
  }


  /*
   * Evitar doble click.
   */
  if (button.disabled) {
    return;
  }


  const originalText =
    button.textContent.trim();


  button.disabled = true;

  button.textContent =
    'Agregando...';


  try {

    /*
     * Agregar al carrito.
     */
    const response = await fetch(
      `${getShopRoot()}cart/add.js`,
      {
        method: 'POST',

        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },

        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1
            }
          ]
        })
      }
    );


    if (!response.ok) {
      throw new Error(
        'No se pudo agregar el producto al carrito'
      );
    }


/*

 * 5. QUITAR DE FAVORITOS

 */

const removeButton =

  event.target.closest(

    '[data-wishlist-remove]'

  );

if (removeButton) {

  event.preventDefault();

  event.stopPropagation();

  const productId =

    removeButton.dataset.wishlistRemove;

  Wishlist.remove(productId);

  renderWishlistDrawer();

  return;

}

    /*
     * Actualizar contenido wishlist.
     */
    await renderWishlistDrawer();


    /*
     * Broadcast: refrescar carrito.
     */
    document.dispatchEvent(
      new CustomEvent(
        'theme:cart:refresh',
        {
          bubbles: true
        }
      )
    );


    /*
     * Cerrar wishlist.
     */
    closeWishlistDrawer();


    /*
     * Esperamos que Broadcast termine de actualizar
     * el contenido del carrito.
     */
    window.setTimeout(
      () => {

        /*
         * Abrir cart drawer.
         */
        document.dispatchEvent(
          new CustomEvent(
            'theme:cart:toggle',
            {
              bubbles: true
            }
          )
        );

      },
      300
    );


  } catch (error) {
    console.error(
      'Wishlist add to cart error:',
      error
    );


    button.disabled = false;

    button.textContent =
      'Error';


    window.setTimeout(
      () => {

        button.textContent =
          originalText;

      },
      1500
    );
  }
}


/* =========================================================
   CLICK GLOBAL
   ========================================================= */

document.addEventListener(
  'click',
  event => {

    /*
     * 1. CORAZÓN PRODUCTO
     */
    const wishlistButton =
      event.target.closest(
        '[data-wishlist-product]'
      );


    if (wishlistButton) {
      event.preventDefault();
      event.stopPropagation();


      const productId =
        wishlistButton.dataset.wishlistProduct;

      const handle =
        wishlistButton.dataset.wishlistHandle || null;


      Wishlist.toggle(
        productId,
        handle
      );


      /*
       * Si wishlist está abierto,
       * actualizar contenido.
       */
      const drawer =
        document.querySelector(
          '[data-wishlist-drawer]'
        );


      if (
        drawer &&
        drawer.classList.contains('is-open')
      ) {
        renderWishlistDrawer();
      }


      return;
    }


    /*
     * 2. ABRIR WISHLIST
     */
    const openButton =
      event.target.closest(
        '[data-wishlist-drawer-toggle]'
      );


    if (openButton) {
      event.preventDefault();

      openWishlistDrawer();

      return;
    }


    /*
     * 3. CERRAR WISHLIST
     */
    const closeButton =
      event.target.closest(
        '[data-wishlist-drawer-close]'
      );


    if (closeButton) {
      event.preventDefault();

      closeWishlistDrawer();

      return;
    }


    /*
     * 4. AGREGAR AL CARRITO
     */
    const addCartButton =
      event.target.closest(
        '[data-wishlist-add-cart]'
      );


    if (addCartButton) {
      event.preventDefault();
      event.stopPropagation();


      addWishlistProductToCart(
        addCartButton
      );


      return;
    }


    /*
     * 5. QUITAR DE FAVORITOS
     */
    const removeButton =
      event.target.closest(
        '[data-wishlist-remove]'
      );


    if (removeButton) {
      event.preventDefault();


      const productId =
        removeButton.dataset.wishlistRemove;


      Wishlist.remove(
        productId
      );


      renderWishlistDrawer();


      return;
    }

  }
);


/* =========================================================
   ESC
   ========================================================= */

document.addEventListener(
  'keydown',
  event => {

    if (event.key === 'Escape') {
      closeWishlistDrawer();
    }

  }
);


/* =========================================================
   ESTADO INICIAL
   ========================================================= */

document.addEventListener(
  'DOMContentLoaded',
  () => {

    Wishlist.refreshUI();

  }
);


/* =========================================================
   SHOPIFY THEME EDITOR
   ========================================================= */

document.addEventListener(
  'shopify:section:load',
  () => {

    Wishlist.refreshUI();

  }
);